import * as Sentry from "@sentry/react";
import { toast } from "react-toastify";
import { LakersBackendApiRequestTimeoutError } from "@/utils/errors";
import { extractApiValidationMessages } from "@/utils/apiErrorMessages";

/** 商業登記と同じ分類で検索エラーを通知する。 */
export const notifySearchError = (error: unknown): void => {
  if (error instanceof LakersBackendApiRequestTimeoutError) {
    toast.info(error.message);
    return;
  }
  const messages = extractApiValidationMessages(error);
  if (messages.length) {
    toast.error(messages.join("\n"));
    return;
  }
  Sentry.captureException(error);
  toast.error("検索に失敗しました。しばらく経ってから再度お試しください。");
};
